import { Box, Button, Chip, FormControlLabel, Grid, Radio, RadioGroup } from '@material-ui/core';
import React, { useRef, useState } from 'react';
import moment from 'moment-timezone';
import { KeyboardDateTimePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import MomentUtils from '@date-io/moment';

import { HomeType, ISegmentCuration, ISegmentCurationType } from '../../services/types';
import useStyles from './styles';
import useSnackbar from '../../hooks/useSnackbar';
import { convertFirstCharacterToUppercase, getStatusByDates } from '../../services/utils/index';

interface LCProps {
  linkedCurations: ISegmentCuration[];
  type: 'featuredcard' | 'collection';
}

export const getSegmentCurationTypeToHomeType = (contentType: ISegmentCurationType): HomeType => {
  switch (contentType) {
    case ISegmentCurationType.AudioFeatured:
    case ISegmentCurationType.AudioCollections:
      return HomeType.LISTEN;
    case ISegmentCurationType.TextFeatured:
    case ISegmentCurationType.TextCollections:
      return HomeType.READ;
    default:
      return HomeType.ALL;
  }
};

export const LinkedCurations = (props: LCProps): JSX.Element => {
  const classes = useStyles();

  return (
    <Box padding={2} width={400}>
      <Grid container spacing={1}>
        <Grid item xs={12}>
          This {props.type === 'featuredcard' ? 'Featured Card' : 'Collection'} is also linked with
        </Grid>
        {props.linkedCurations?.map((curation, idx) => {
          const statusText = getStatusByDates(curation.startsAt, curation.endsAt);
          const curationType =
            getSegmentCurationTypeToHomeType(curation.type) === HomeType.ALL
              ? 'Default'
              : ((getSegmentCurationTypeToHomeType(curation.type) as unknown) as string);
          return (
            <Grid item xs={12} key={`linked-curation-key-${curation.id!}-${idx}`}>
              <Grid container alignContent="stretch">
                <Chip
                  size="small"
                  label={curation.segment!.isActive ? 'Activated' : 'Deactivated'}
                  color={curation.segment!.isActive ? 'primary' : 'default'}
                  style={{ marginRight: 8, color: curation.segment!.isActive ? undefined : '#666666' }}
                />
                <div className={classes.popoverItemTitle}>
                  <span className={classes.popoverPriority}>{`0000${curation.priority}`.substr(-4)}</span> {curation.segment?.name}(
                  {curation.segment?.userCount?.toLocaleString() || 0})
                </div>
                <div className={classes.popoverPriority}>{convertFirstCharacterToUppercase(curationType) || '-'}</div>
              </Grid>
            </Grid>
          );
        })}
      </Grid>
    </Box>
  );
};

interface SSProps {
  value: Date | null;
  type: 'startsAt' | 'endsAt';
  onChangeDate: (value: Date | null) => void;
  onCancel: () => void;
}

export const ScheduleSelect = (props: SSProps): JSX.Element => {
  const classes = useStyles();
  const snackbar = useSnackbar();

  const [dateValue, setDateValue] = useState<Date | null>(props.value ? props.value : null);
  const [scheduleType, setScheduleType] = useState<'rightnow' | 'none' | 'scheduled'>(
    props.value ? 'scheduled' : props.type === 'startsAt' ? 'rightnow' : 'none',
  );
  const [showCalendar, setShowCalendar] = useState<boolean>(false);

  const onChange = (date: any, value: any) => {
    if (value) {
      setDateValue(date);
      setShowCalendar(false);
      // props.onChangeDate(value);
    }
  };
  const onSave = () => {
    if (scheduleType === 'rightnow') {
      props.onChangeDate(new Date());
    } else if (scheduleType === 'none') {
      props.onChangeDate(null);
    } else {
      props.onChangeDate(dateValue || null);
    }
  };

  return (
    <Box padding={2} width={460}>
      <Grid container spacing={1} alignContent="center" alignItems="center">
        <Grid item xs={12}>
          Scheduling
        </Grid>
        <Grid item xs={4}>
          Start
        </Grid>
        <Grid item xs={8}>
          <RadioGroup
            row
            value={scheduleType}
            name="scheduletype"
            onChange={e => {
              setScheduleType(e.target.value as 'rightnow' | 'none' | 'scheduled');
            }}
          >
            <FormControlLabel
              control={<Radio value={props.type === 'startsAt' ? 'rightnow' : 'none'} color="primary" className={''} />}
              label={props.type === 'startsAt' ? 'Right now' : 'None'}
            />
            <FormControlLabel control={<Radio value="scheduled" color="primary" />} label="Scheduled" />
          </RadioGroup>
        </Grid>
        <Grid item xs={4}>
          Scheduled
          <br />
          Date
        </Grid>
        <Grid item xs={8}>
          <MuiPickersUtilsProvider utils={MomentUtils}>
            <KeyboardDateTimePicker
              format="lll"
              required
              margin="normal"
              id="date-picker-inline"
              value={dateValue}
              onChange={onChange}
              onClick={() => {
                scheduleType === 'scheduled' && setShowCalendar(true);
              }}
              onClose={() => setShowCalendar(false)}
              open={showCalendar}
              // className={classes.radioButtonGroups}
              disabled={scheduleType !== 'scheduled'}
            />
          </MuiPickersUtilsProvider>
        </Grid>
        <Grid item xs={12}>
          <Button onClick={props.onCancel}>Cancel</Button>
          <Button color="primary" variant="contained" onClick={onSave}>
            Save
          </Button>
        </Grid>
      </Grid>
    </Box>
  );
};
